import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ExpandArrowIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.14393 0.675539L4.16952 5.21037L7.19188 0.673389L8.0168 1.2229L4.17016 6.99724L0.319407 1.22564L1.14393 0.675539Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default ExpandArrowIcon;

ExpandArrowIcon.propTypes = customIconsPropTypes;
